class UserProfile {
    id: number;
    name: string;
    externalId: number;
    config: UserProfileConfig;

    constructor(data: any) {
        this.id = data?.id ?? 0;
        this.name = data?.name ?? "New User Profile";
        this.externalId = data?.externalId ?? 0;
        this.config = new UserProfileConfig(data?.config);
    }

    save(isNew: boolean = false, sucessCallback: (result: any) => void, failureCallback: () => void) {
        let model = {
            isNew: isNew,
            userProfile: this,
            permissionsSelected: this.config.permissionsSelected
        };

        let o = {
            url: urlConfigs.userProfiles + "/Save",
            data: model,
            dataType: "json",
            async: false
        } as RequestServerParams;
        o.successFunction = function (data, e) {
            if (data.success) {
                if (model.isNew) {
                    model.userProfile.id = data.id;
                    model.userProfile.externalId = data.externalId;
                }

                if (sucessCallback) {
                    sucessCallback(data);
                }
            }
            else {
                let errorItem = { userMessage: "Failed to save user profile" } as IError;
                irGlobal.defaultErrorFunction(errorItem.userMessage, data.message, "");

                if (failureCallback) {
                    failureCallback();
                }
            }
        };
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = "Failed to save user profile";
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);

            if (failureCallback) {
                failureCallback();
            }
        };

        irGlobal.requestServer(o);

    }

    delete(sucessCallback: (result: any) => void) {
        let o = {
            url: urlConfigs.userProfiles + "/Delete",
            data: { id: this.id },
            dataType: "json",
            async: false
        } as RequestServerParams;
        o.successFunction = function (data, e) {
            sucessCallback(data);
        };
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = "Failed to delete user profile";
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);
    }
}

class UserProfileConfig {
    permissionsSelected: Array<number>;

    constructor(data: any) {
        this.permissionsSelected = data?.permissionsSelected ?? [];

        if (data) {
            for (const property in data.permissions) {
                if (data.permissions[property]) {
                    this.permissionsSelected.push(parseInt(property));
                }
            }
        }
    }
}